import React from "react";
import Card from "../../../common/element/Card";
import Heading from "../../../common/element/Heading";
import BtnPrimary from "../../../common/element/Buttons/btnPrimary";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
const PaymentInvoiceSuccess = () => {
  const location = useLocation();
  let invoiceData = location?.state?.data;
  const downloadInvoice = () => {
    if (invoiceData && invoiceData.xero_invoice_pdf) {
      const link = document.createElement("a");
      link.href = invoiceData.xero_invoice_pdf;
      link.download = "invoice.pdf";
      link.target = "_blank";
      link.click();
    } else {
      console.error("No PDF URL found in invoice data");
    }
  };

  const hasProviderSessionFromFlow = location?.state?.hasProviderSession;
  const token = localStorage.getItem("conserve_authtoken");
  const continueHref =
    hasProviderSessionFromFlow || token ? "/provider/dashboard" : "/login";
  return (
    <div
      style={{ backgroundColor: `#eff8ff` }}
      className="flex justify-center min-h-screen pr-6 pl-6"
    >
      <div className="min-h-screen justify-center flex  py-12 px-4">
        <div className="flex-col items-center justify-center flex">
          <div className="flex items-center mb-6">
            <img className="brand-img" src="/assets/logo.svg" alt="conserve" />
          </div>
          <Heading className="text-center mb-3">Payment successful</Heading>
          <p className="text-base text-gray-600 text-center font-semibold max-w-lg mb-7">
            Thank you for your payment. A confirmation of this <br />{" "}
            transaction has been sent to your email.
          </p>
          <Card className="w-440 rounded-xl   block-shadow w-100 px-10 py-8 mb-7">
            <div className="flex flex-col mb-7">
              <p className="text-gray-700 font-bold text-base mb-1">
                Total Amount
              </p>
              <span className="text-gray-700">${invoiceData?.amount}</span>
            </div>
            <div className="flex flex-col mb-7">
              <p className="text-gray-700 font-bold text-base mb-1">
                License Period
              </p>
              <p className="text-gray-700">
                {moment(new Date()).format("DD/MM/YYYY")} -{" "}
                {moment(invoiceData?.end_date).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="flex flex-col">
              <p className="text-gray-700 font-bold text-base mb-1">
                Invoice Number
              </p>
              <span className="text-gray-700">
                {invoiceData?.xero_invoice_number}
              </span>
              <button
                className="flex gap-1  text-blue-700 hover:text-blue-900 focus:text-blue-700"
                onClick={downloadInvoice}
              >
                Download invoice{" "}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.583 13.2866V14.2866C17.583 15.6868 17.583 16.3868 17.3105 16.9216C17.0708 17.392 16.6884 17.7745 16.218 18.0141C15.6832 18.2866 14.9831 18.2866 13.583 18.2866H6.58301C5.18288 18.2866 4.48281 18.2866 3.94803 18.0141C3.47763 17.7745 3.09517 17.392 2.85549 16.9216C2.58301 16.3868 2.58301 15.6868 2.58301 14.2866V13.2866M14.2497 9.11995L10.083 13.2866M10.083 13.2866L5.91634 9.11995M10.083 13.2866V3.28662"
                    stroke="#5786CC"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </Card>
          <div className="px-10 w-full">
            <BtnPrimary className="text-xs h-9">
              <Link to={continueHref}>Continue to Conserve App</Link>
              <Link to={continueHref}>Continue to Conserve App</Link>
            </BtnPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInvoiceSuccess;
